import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MoreComponent } from './more.component';
import { TranslateSharedLazyModule } from '../../../../app-shared/modules/translate-shared-lazy.module';
import {ClipboardModule} from "@angular/cdk/clipboard";
import {ChangeOutletModule} from "../../change-outlet/change-outlet.module";
import {UserNotificationModule} from "../../../user-notification/user-notification.module";

@NgModule({
  declarations: [MoreComponent],
    imports: [
      CommonModule,
      TranslateSharedLazyModule,
      ClipboardModule,
      ChangeOutletModule,
      UserNotificationModule
    ],
  exports: [MoreComponent],
})
export class MoreModule {}
